const styles = {
	wrapper: {
		alignItems: 'center',
		button: {
			display: 'inline-flex',
			marginLeft: '8px',
		},
	},
	title: {
		color: 'primary',
		fontSize: ['14px', '15px'],
	},
};

export default styles;
